// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.MuCentralOffice_dashboardContainer__4M-l5 {
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
}

.MuCentralOffice_dashboardContent__SM0Wx {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  padding: 40px;
  max-width: 1200px;
  width: 100%;
  text-align: center;
}

.MuCentralOffice_header__n9TgT {
  margin-bottom: 40px;
}

.MuCentralOffice_logoSection__fbV04 {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  margin-bottom: 20px;
}

.MuCentralOffice_logo__QyZz7 {
  font-size: 4rem;
  filter: drop-shadow(2px 2px 4px rgba(0, 0, 0, 0.1));
}

.MuCentralOffice_titleSection__bfX1T {
  text-align: left;
}
.MuCentralOffice_titleSection__bfX1T h1 {
  color: #2c3e50;
  font-size: 2.5rem;
  font-weight: 700;
  margin: 0 0 5px 0;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
}
.MuCentralOffice_titleSection__bfX1T h2 {
  color: #667eea;
  font-size: 1.8rem;
  font-weight: 600;
  margin: 0 0 5px 0;
}
.MuCentralOffice_titleSection__bfX1T h3 {
  color: #7f8c8d;
  font-size: 1.3rem;
  font-weight: 500;
  margin: 0 0 5px 0;
  text-transform: uppercase;
  letter-spacing: 1px;
}
.MuCentralOffice_titleSection__bfX1T p {
  color: #95a5a6;
  font-size: 1rem;
  margin: 0;
  font-style: italic;
}

.MuCentralOffice_cardsContainer__Q4fOe {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
  margin-bottom: 40px;
}

.MuCentralOffice_card__tTwST {
  background: linear-gradient(145deg, #ffffff, #f0f0f0);
  border-radius: 15px;
  padding: 30px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  border: 2px solid transparent;
}
.MuCentralOffice_card__tTwST::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #667eea, #764ba2);
  transform: scaleX(0);
  transition: transform 0.3s ease;
}
.MuCentralOffice_card__tTwST:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15);
  border-color: #667eea;
}
.MuCentralOffice_card__tTwST:hover::before {
  transform: scaleX(1);
}
.MuCentralOffice_card__tTwST:hover .MuCentralOffice_cardArrow__W9WwH {
  transform: translateX(5px);
  opacity: 1;
}
.MuCentralOffice_card__tTwST:active {
  transform: translateY(-5px);
}

.MuCentralOffice_cardIcon__h4Fzx {
  font-size: 3rem;
  margin-bottom: 20px;
  display: block;
}

.MuCentralOffice_cardContent__3vEjB h3 {
  color: #2c3e50;
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0 0 10px 0;
}
.MuCentralOffice_cardContent__3vEjB p {
  color: #7f8c8d;
  font-size: 1rem;
  line-height: 1.6;
  margin: 0 0 15px 0;
}

.MuCentralOffice_adminCard__7p2vu {
  border-color: #e74c3c;
}
.MuCentralOffice_adminCard__7p2vu:hover {
  border-color: #c0392b;
  background: linear-gradient(145deg, #fff5f5, #ffe6e6);
}

.MuCentralOffice_publicCard__io9nV {
  border-color: #27ae60;
}
.MuCentralOffice_publicCard__io9nV:hover {
  border-color: #229954;
  background: linear-gradient(145deg, #f5fff5, #e6ffe6);
}

.MuCentralOffice_authBadge__CpgI9, .MuCentralOffice_publicBadge__nM4Hf {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 0.8rem;
  font-weight: 600;
  padding: 4px 8px;
  border-radius: 12px;
  margin-top: 10px;
}

.MuCentralOffice_authBadge__CpgI9 {
  background: linear-gradient(135deg, #e74c3c, #c0392b);
  color: white;
}
.MuCentralOffice_authBadge__CpgI9 .MuCentralOffice_authIcon__1rgLT {
  font-size: 0.9rem;
}

.MuCentralOffice_publicBadge__nM4Hf {
  background: linear-gradient(135deg, #27ae60, #229954);
  color: white;
}
.MuCentralOffice_publicBadge__nM4Hf .MuCentralOffice_publicIcon__Ana7h {
  font-size: 0.9rem;
}

.MuCentralOffice_cardArrow__W9WwH {
  position: absolute;
  top: 20px;
  right: 20px;
  font-size: 1.5rem;
  color: #667eea;
  opacity: 0.7;
  transition: all 0.3s ease;
}

.MuCentralOffice_infoSection__63aoh {
  margin: 40px 0;
}

.MuCentralOffice_infoCard__sWinY {
  background: linear-gradient(145deg, #f8f9fa, #e9ecef);
  border-radius: 15px;
  padding: 25px;
  border-left: 4px solid #667eea;
}
.MuCentralOffice_infoCard__sWinY h4 {
  color: #2c3e50;
  font-size: 1.2rem;
  font-weight: 600;
  margin: 0 0 15px 0;
}
.MuCentralOffice_infoCard__sWinY ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.MuCentralOffice_infoCard__sWinY ul li {
  color: #5a6c7d;
  font-size: 0.95rem;
  line-height: 1.6;
  margin-bottom: 8px;
  padding-left: 20px;
  position: relative;
}
.MuCentralOffice_infoCard__sWinY ul li::before {
  content: "•";
  color: #667eea;
  font-weight: bold;
  position: absolute;
  left: 0;
}
.MuCentralOffice_infoCard__sWinY ul li strong {
  color: #2c3e50;
  font-weight: 600;
}

.MuCentralOffice_footer__9nIuB {
  color: #7f8c8d;
  font-size: 1rem;
  font-style: italic;
  margin-top: 20px;
  text-align: center;
}

.MuCentralOffice_footerLinks__zY0ZN {
  margin-top: 10px;
}
.MuCentralOffice_footerLinks__zY0ZN span {
  color: #667eea;
  font-size: 0.9rem;
  cursor: pointer;
  transition: color 0.3s ease;
}
.MuCentralOffice_footerLinks__zY0ZN span:hover {
  color: #5a6c7d;
  text-decoration: underline;
}

@media (max-width: 1200px) {
  .MuCentralOffice_dashboardContent__SM0Wx {
    max-width: 95%;
    padding: 30px;
  }
  .MuCentralOffice_cardsContainer__Q4fOe {
    gap: 25px;
  }
}
@media (max-width: 768px) {
  .MuCentralOffice_dashboardContainer__4M-l5 {
    padding: 15px;
  }
  .MuCentralOffice_dashboardContent__SM0Wx {
    padding: 25px;
  }
  .MuCentralOffice_header__n9TgT {
    margin-bottom: 30px;
  }
  .MuCentralOffice_logoSection__fbV04 {
    flex-direction: column;
    gap: 15px;
  }
  .MuCentralOffice_logo__QyZz7 {
    font-size: 3rem;
  }
  .MuCentralOffice_titleSection__bfX1T {
    text-align: center;
  }
  .MuCentralOffice_titleSection__bfX1T h1 {
    font-size: 2rem;
  }
  .MuCentralOffice_titleSection__bfX1T h2 {
    font-size: 1.4rem;
  }
  .MuCentralOffice_titleSection__bfX1T h3 {
    font-size: 1.1rem;
  }
  .MuCentralOffice_cardsContainer__Q4fOe {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  .MuCentralOffice_card__tTwST {
    padding: 25px;
  }
  .MuCentralOffice_cardIcon__h4Fzx {
    font-size: 2.5rem;
  }
  .MuCentralOffice_cardContent__3vEjB h3 {
    font-size: 1.3rem;
  }
}
@media (max-width: 480px) {
  .MuCentralOffice_dashboardContainer__4M-l5 {
    padding: 10px;
  }
  .MuCentralOffice_dashboardContent__SM0Wx {
    padding: 20px;
    border-radius: 15px;
  }
  .MuCentralOffice_header__n9TgT {
    margin-bottom: 25px;
  }
  .MuCentralOffice_header__n9TgT h1 {
    font-size: 1.8rem;
  }
  .MuCentralOffice_header__n9TgT h2 {
    font-size: 1rem;
  }
  .MuCentralOffice_card__tTwST {
    padding: 20px;
  }
  .MuCentralOffice_cardIcon__h4Fzx {
    font-size: 2rem;
    margin-bottom: 15px;
  }
  .MuCentralOffice_cardContent__3vEjB h3 {
    font-size: 1.2rem;
  }
  .MuCentralOffice_cardContent__3vEjB p {
    font-size: 0.9rem;
  }
  .MuCentralOffice_footer__9nIuB {
    font-size: 0.9rem;
  }
}
@media (max-width: 360px) {
  .MuCentralOffice_dashboardContent__SM0Wx {
    padding: 15px;
  }
  .MuCentralOffice_header__n9TgT h1 {
    font-size: 1.5rem;
  }
  .MuCentralOffice_header__n9TgT h2 {
    font-size: 1.2rem;
  }
  .MuCentralOffice_header__n9TgT h3 {
    font-size: 1rem;
  }
  .MuCentralOffice_logo__QyZz7 {
    font-size: 2.5rem;
  }
  .MuCentralOffice_infoCard__sWinY {
    padding: 20px;
  }
  .MuCentralOffice_infoCard__sWinY h4 {
    font-size: 1.1rem;
  }
  .MuCentralOffice_infoCard__sWinY ul li {
    font-size: 0.9rem;
  }
  .MuCentralOffice_card__tTwST {
    padding: 15px;
  }
  .MuCentralOffice_cardIcon__h4Fzx {
    font-size: 1.8rem;
  }
  .MuCentralOffice_cardContent__3vEjB h3 {
    font-size: 1.1rem;
  }
  .MuCentralOffice_cardContent__3vEjB p {
    font-size: 0.85rem;
  }
}
@keyframes MuCentralOffice_fadeInUp__zVYtl {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.MuCentralOffice_dashboardContent__SM0Wx {
  animation: MuCentralOffice_fadeInUp__zVYtl 0.6s ease-out;
}

.MuCentralOffice_card__tTwST {
  animation: MuCentralOffice_fadeInUp__zVYtl 0.6s ease-out;
}
.MuCentralOffice_card__tTwST:nth-child(1) {
  animation-delay: 0.1s;
}
.MuCentralOffice_card__tTwST:nth-child(2) {
  animation-delay: 0.2s;
}
.MuCentralOffice_card__tTwST:nth-child(3) {
  animation-delay: 0.3s;
}`, "",{"version":3,"sources":["webpack://./src/components/bank-details/MuCentralOffice.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,iBAAA;EACA,6DAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;AAEF;;AACA;EACE,qCAAA;EACA,2BAAA;EACA,mBAAA;EACA,0CAAA;EACA,aAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;AAEF;;AACA;EACE,mBAAA;AAEF;;AACA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AAEF;;AACA;EACE,eAAA;EACA,mDAAA;AAEF;;AACA;EACE,gBAAA;AAEF;AAAE;EACE,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,2CAAA;AAEJ;AACE;EACE,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;AACJ;AAEE;EACE,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;AAAJ;AAGE;EACE,cAAA;EACA,eAAA;EACA,SAAA;EACA,kBAAA;AADJ;;AAKA;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,mBAAA;AAFF;;AAKA;EACE,qDAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6BAAA;AAFF;AAIE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,oDAAA;EACA,oBAAA;EACA,+BAAA;AAFJ;AAKE;EACE,4BAAA;EACA,2CAAA;EACA,qBAAA;AAHJ;AAKI;EACE,oBAAA;AAHN;AAMI;EACE,0BAAA;EACA,UAAA;AAJN;AAQE;EACE,2BAAA;AANJ;;AAUA;EACE,eAAA;EACA,mBAAA;EACA,cAAA;AAPF;;AAWE;EACE,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AARJ;AAWE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AATJ;;AAcA;EACE,qBAAA;AAXF;AAaE;EACE,qBAAA;EACA,qDAAA;AAXJ;;AAeA;EACE,qBAAA;AAZF;AAcE;EACE,qBAAA;EACA,qDAAA;AAZJ;;AAiBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AAdF;;AAiBA;EACE,qDAAA;EACA,YAAA;AAdF;AAgBE;EACE,iBAAA;AAdJ;;AAkBA;EACE,qDAAA;EACA,YAAA;AAfF;AAiBE;EACE,iBAAA;AAfJ;;AAmBA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;EACA,YAAA;EACA,yBAAA;AAhBF;;AAmBA;EACE,cAAA;AAhBF;;AAmBA;EACE,qDAAA;EACA,mBAAA;EACA,aAAA;EACA,8BAAA;AAhBF;AAkBE;EACE,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AAhBJ;AAmBE;EACE,gBAAA;EACA,UAAA;EACA,SAAA;AAjBJ;AAmBI;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;AAjBN;AAmBM;EACE,YAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,OAAA;AAjBR;AAoBM;EACE,cAAA;EACA,gBAAA;AAlBR;;AAwBA;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AArBF;;AAwBA;EACE,gBAAA;AArBF;AAuBE;EACE,cAAA;EACA,iBAAA;EACA,eAAA;EACA,2BAAA;AArBJ;AAuBI;EACE,cAAA;EACA,0BAAA;AArBN;;AA2BA;EACE;IACE,cAAA;IACA,aAAA;EAxBF;EA2BA;IACE,SAAA;EAzBF;AACF;AA4BA;EACE;IACE,aAAA;EA1BF;EA6BA;IACE,aAAA;EA3BF;EA8BA;IACE,mBAAA;EA5BF;EA+BA;IACE,sBAAA;IACA,SAAA;EA7BF;EAgCA;IACE,eAAA;EA9BF;EAiCA;IACE,kBAAA;EA/BF;EAiCE;IACE,eAAA;EA/BJ;EAkCE;IACE,iBAAA;EAhCJ;EAmCE;IACE,iBAAA;EAjCJ;EAqCA;IACE,0BAAA;IACA,SAAA;EAnCF;EAsCA;IACE,aAAA;EApCF;EAuCA;IACE,iBAAA;EArCF;EAyCE;IACE,iBAAA;EAvCJ;AACF;AA2CA;EACE;IACE,aAAA;EAzCF;EA4CA;IACE,aAAA;IACA,mBAAA;EA1CF;EA6CA;IACE,mBAAA;EA3CF;EA6CE;IACE,iBAAA;EA3CJ;EA8CE;IACE,eAAA;EA5CJ;EAgDA;IACE,aAAA;EA9CF;EAiDA;IACE,eAAA;IACA,mBAAA;EA/CF;EAmDE;IACE,iBAAA;EAjDJ;EAoDE;IACE,iBAAA;EAlDJ;EAsDA;IACE,iBAAA;EApDF;AACF;AAuDA;EACE;IACE,aAAA;EArDF;EAyDE;IACE,iBAAA;EAvDJ;EA0DE;IACE,iBAAA;EAxDJ;EA2DE;IACE,eAAA;EAzDJ;EA6DA;IACE,iBAAA;EA3DF;EA8DA;IACE,aAAA;EA5DF;EA8DE;IACE,iBAAA;EA5DJ;EA+DE;IACE,iBAAA;EA7DJ;EAiEA;IACE,aAAA;EA/DF;EAkEA;IACE,iBAAA;EAhEF;EAoEE;IACE,iBAAA;EAlEJ;EAqEE;IACE,kBAAA;EAnEJ;AACF;AAwEA;EACE;IACE,UAAA;IACA,2BAAA;EAtEF;EAwEA;IACE,UAAA;IACA,wBAAA;EAtEF;AACF;AAyEA;EACE,wDAAA;AAvEF;;AA0EA;EACE,wDAAA;AAvEF;AAyEE;EACE,qBAAA;AAvEJ;AA0EE;EACE,qBAAA;AAxEJ;AA2EE;EACE,qBAAA;AAzEJ","sourcesContent":[".dashboardContainer {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  box-sizing: border-box;\n}\n\n.dashboardContent {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(10px);\n  border-radius: 20px;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);\n  padding: 40px;\n  max-width: 1200px;\n  width: 100%;\n  text-align: center;\n}\n\n.header {\n  margin-bottom: 40px;\n}\n\n.logoSection {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 20px;\n  margin-bottom: 20px;\n}\n\n.logo {\n  font-size: 4rem;\n  filter: drop-shadow(2px 2px 4px rgba(0, 0, 0, 0.1));\n}\n\n.titleSection {\n  text-align: left;\n  \n  h1 {\n    color: #2c3e50;\n    font-size: 2.5rem;\n    font-weight: 700;\n    margin: 0 0 5px 0;\n    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);\n  }\n  \n  h2 {\n    color: #667eea;\n    font-size: 1.8rem;\n    font-weight: 600;\n    margin: 0 0 5px 0;\n  }\n  \n  h3 {\n    color: #7f8c8d;\n    font-size: 1.3rem;\n    font-weight: 500;\n    margin: 0 0 5px 0;\n    text-transform: uppercase;\n    letter-spacing: 1px;\n  }\n  \n  p {\n    color: #95a5a6;\n    font-size: 1rem;\n    margin: 0;\n    font-style: italic;\n  }\n}\n\n.cardsContainer {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 30px;\n  margin-bottom: 40px;\n}\n\n.card {\n  background: linear-gradient(145deg, #ffffff, #f0f0f0);\n  border-radius: 15px;\n  padding: 30px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  position: relative;\n  overflow: hidden;\n  border: 2px solid transparent;\n  \n  &::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: 4px;\n    background: linear-gradient(90deg, #667eea, #764ba2);\n    transform: scaleX(0);\n    transition: transform 0.3s ease;\n  }\n  \n  &:hover {\n    transform: translateY(-10px);\n    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15);\n    border-color: #667eea;\n    \n    &::before {\n      transform: scaleX(1);\n    }\n    \n    .cardArrow {\n      transform: translateX(5px);\n      opacity: 1;\n    }\n  }\n  \n  &:active {\n    transform: translateY(-5px);\n  }\n}\n\n.cardIcon {\n  font-size: 3rem;\n  margin-bottom: 20px;\n  display: block;\n}\n\n.cardContent {\n  h3 {\n    color: #2c3e50;\n    font-size: 1.5rem;\n    font-weight: 600;\n    margin: 0 0 10px 0;\n  }\n  \n  p {\n    color: #7f8c8d;\n    font-size: 1rem;\n    line-height: 1.6;\n    margin: 0 0 15px 0;\n  }\n}\n\n// Card types\n.adminCard {\n  border-color: #e74c3c;\n  \n  &:hover {\n    border-color: #c0392b;\n    background: linear-gradient(145deg, #fff5f5, #ffe6e6);\n  }\n}\n\n.publicCard {\n  border-color: #27ae60;\n  \n  &:hover {\n    border-color: #229954;\n    background: linear-gradient(145deg, #f5fff5, #e6ffe6);\n  }\n}\n\n// Badges\n.authBadge, .publicBadge {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  padding: 4px 8px;\n  border-radius: 12px;\n  margin-top: 10px;\n}\n\n.authBadge {\n  background: linear-gradient(135deg, #e74c3c, #c0392b);\n  color: white;\n  \n  .authIcon {\n    font-size: 0.9rem;\n  }\n}\n\n.publicBadge {\n  background: linear-gradient(135deg, #27ae60, #229954);\n  color: white;\n  \n  .publicIcon {\n    font-size: 0.9rem;\n  }\n}\n\n.cardArrow {\n  position: absolute;\n  top: 20px;\n  right: 20px;\n  font-size: 1.5rem;\n  color: #667eea;\n  opacity: 0.7;\n  transition: all 0.3s ease;\n}\n\n.infoSection {\n  margin: 40px 0;\n}\n\n.infoCard {\n  background: linear-gradient(145deg, #f8f9fa, #e9ecef);\n  border-radius: 15px;\n  padding: 25px;\n  border-left: 4px solid #667eea;\n  \n  h4 {\n    color: #2c3e50;\n    font-size: 1.2rem;\n    font-weight: 600;\n    margin: 0 0 15px 0;\n  }\n  \n  ul {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    \n    li {\n      color: #5a6c7d;\n      font-size: 0.95rem;\n      line-height: 1.6;\n      margin-bottom: 8px;\n      padding-left: 20px;\n      position: relative;\n      \n      &::before {\n        content: '•';\n        color: #667eea;\n        font-weight: bold;\n        position: absolute;\n        left: 0;\n      }\n      \n      strong {\n        color: #2c3e50;\n        font-weight: 600;\n      }\n    }\n  }\n}\n\n.footer {\n  color: #7f8c8d;\n  font-size: 1rem;\n  font-style: italic;\n  margin-top: 20px;\n  text-align: center;\n}\n\n.footerLinks {\n  margin-top: 10px;\n  \n  span {\n    color: #667eea;\n    font-size: 0.9rem;\n    cursor: pointer;\n    transition: color 0.3s ease;\n    \n    &:hover {\n      color: #5a6c7d;\n      text-decoration: underline;\n    }\n  }\n}\n\n// Responsive Design\n@media (max-width: 1200px) {\n  .dashboardContent {\n    max-width: 95%;\n    padding: 30px;\n  }\n  \n  .cardsContainer {\n    gap: 25px;\n  }\n}\n\n@media (max-width: 768px) {\n  .dashboardContainer {\n    padding: 15px;\n  }\n  \n  .dashboardContent {\n    padding: 25px;\n  }\n  \n  .header {\n    margin-bottom: 30px;\n  }\n  \n  .logoSection {\n    flex-direction: column;\n    gap: 15px;\n  }\n  \n  .logo {\n    font-size: 3rem;\n  }\n  \n  .titleSection {\n    text-align: center;\n    \n    h1 {\n      font-size: 2rem;\n    }\n    \n    h2 {\n      font-size: 1.4rem;\n    }\n    \n    h3 {\n      font-size: 1.1rem;\n    }\n  }\n  \n  .cardsContainer {\n    grid-template-columns: 1fr;\n    gap: 20px;\n  }\n  \n  .card {\n    padding: 25px;\n  }\n  \n  .cardIcon {\n    font-size: 2.5rem;\n  }\n  \n  .cardContent {\n    h3 {\n      font-size: 1.3rem;\n    }\n  }\n}\n\n@media (max-width: 480px) {\n  .dashboardContainer {\n    padding: 10px;\n  }\n  \n  .dashboardContent {\n    padding: 20px;\n    border-radius: 15px;\n  }\n  \n  .header {\n    margin-bottom: 25px;\n    \n    h1 {\n      font-size: 1.8rem;\n    }\n    \n    h2 {\n      font-size: 1rem;\n    }\n  }\n  \n  .card {\n    padding: 20px;\n  }\n  \n  .cardIcon {\n    font-size: 2rem;\n    margin-bottom: 15px;\n  }\n  \n  .cardContent {\n    h3 {\n      font-size: 1.2rem;\n    }\n    \n    p {\n      font-size: 0.9rem;\n    }\n  }\n  \n  .footer {\n    font-size: 0.9rem;\n  }\n}\n\n@media (max-width: 360px) {\n  .dashboardContent {\n    padding: 15px;\n  }\n  \n  .header {\n    h1 {\n      font-size: 1.5rem;\n    }\n    \n    h2 {\n      font-size: 1.2rem;\n    }\n    \n    h3 {\n      font-size: 1rem;\n    }\n  }\n  \n  .logo {\n    font-size: 2.5rem;\n  }\n  \n  .infoCard {\n    padding: 20px;\n    \n    h4 {\n      font-size: 1.1rem;\n    }\n    \n    ul li {\n      font-size: 0.9rem;\n    }\n  }\n  \n  .card {\n    padding: 15px;\n  }\n  \n  .cardIcon {\n    font-size: 1.8rem;\n  }\n  \n  .cardContent {\n    h3 {\n      font-size: 1.1rem;\n    }\n    \n    p {\n      font-size: 0.85rem;\n    }\n  }\n}\n\n// Animation for page load\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.dashboardContent {\n  animation: fadeInUp 0.6s ease-out;\n}\n\n.card {\n  animation: fadeInUp 0.6s ease-out;\n  \n  &:nth-child(1) {\n    animation-delay: 0.1s;\n  }\n  \n  &:nth-child(2) {\n    animation-delay: 0.2s;\n  }\n  \n  &:nth-child(3) {\n    animation-delay: 0.3s;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboardContainer": `MuCentralOffice_dashboardContainer__4M-l5`,
	"dashboardContent": `MuCentralOffice_dashboardContent__SM0Wx`,
	"header": `MuCentralOffice_header__n9TgT`,
	"logoSection": `MuCentralOffice_logoSection__fbV04`,
	"logo": `MuCentralOffice_logo__QyZz7`,
	"titleSection": `MuCentralOffice_titleSection__bfX1T`,
	"cardsContainer": `MuCentralOffice_cardsContainer__Q4fOe`,
	"card": `MuCentralOffice_card__tTwST`,
	"cardArrow": `MuCentralOffice_cardArrow__W9WwH`,
	"cardIcon": `MuCentralOffice_cardIcon__h4Fzx`,
	"cardContent": `MuCentralOffice_cardContent__3vEjB`,
	"adminCard": `MuCentralOffice_adminCard__7p2vu`,
	"publicCard": `MuCentralOffice_publicCard__io9nV`,
	"authBadge": `MuCentralOffice_authBadge__CpgI9`,
	"publicBadge": `MuCentralOffice_publicBadge__nM4Hf`,
	"authIcon": `MuCentralOffice_authIcon__1rgLT`,
	"publicIcon": `MuCentralOffice_publicIcon__Ana7h`,
	"infoSection": `MuCentralOffice_infoSection__63aoh`,
	"infoCard": `MuCentralOffice_infoCard__sWinY`,
	"footer": `MuCentralOffice_footer__9nIuB`,
	"footerLinks": `MuCentralOffice_footerLinks__zY0ZN`,
	"fadeInUp": `MuCentralOffice_fadeInUp__zVYtl`
};
export default ___CSS_LOADER_EXPORT___;
